<template>
	<div class="step3">
		<div class="content">
			<label class="header">Please verify the information below is correct.</label>
			<span class="detail">Appointment Location: <strong>{{ displayClinicAddress }}</strong></span>
			<span class="detail">Appointment Type: <strong>{{ displayAppointmentType }}</strong></span>
			<span class="detail">Appointment Date: <strong>{{ displayAppointmentDate }}</strong></span>
			<span class="detail">Appointment Time: <strong>{{ displayAppointmentTime }}</strong></span>
			<span class="detail">First Name: <strong>{{ patient.firstName }}</strong></span>
			<span class="detail">Last Name: <strong>{{ patient.lastName }}</strong></span>
			<span class="detail">Email Address: <strong>{{ patient.emailAddress }}</strong></span>
			<span class="detail">Phone Number: <strong>{{ patient.phoneNumber }}</strong></span>
			<template v-if="patient.bringingFamiliarVoice">
				<span class="detail">Familiar Voice: <strong>{{ patient.familiarVoiceFirstName }} {{ patient.familiarVoiceLastName}}</strong></span>
				<span class="detail">Familiar Voice Relation: <strong>{{ patient.relation.name }}</strong></span>
			</template>
		  <fieldset>
			  <input placeholder="Verify Email Address*"
					      type="email"
					      tabindex="3"
					      required
					      class="emailAddressVerify"
					      v-model="form.emailAddressVerify">
		  </fieldset>
			<!-- reCAPTCHA widget -->
			<!--<div class="recaptcha-row">
				<div class="g-recaptcha"
				     ref="recaptcha"/>
			</div>-->
			<label v-if="!recaptchaSuccess" class="recaptcha-error">Please check the "I'm not a robot" box to continue</label>
		</div>
		<div class="footer-actions">
			<button class="btn-beltone xl" :class="{'disabled': submitting}" @click="prevStep()">Back</button>
			<button class="btn-beltone xl" :class="{'disabled': submitting}" @click="complete()">
				<div v-show="submitting" class="btn-spinner">
					<div class="outer"><div class="inner"><span></span></div></div>
				</div>
				<span :class="{'hidden': submitting}">Continue</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Services from '../../mixins/services';

export default {
	mixins: [Services],

	data: function () {
		return {
			submitting: false,
			form: {
				emailAddressVerify: ''
			},
			recaptchaSiteKey: "6Le-5TIrAAAAAPx8Rmyk5V42XLxrp8_TBXO9XLog",
			recaptchaResponse: '',
			recaptchaRendered: false,
			recaptchaSuccess: true,
		}
	},
	computed: mapState({
		patient: state => state.OnlineScheduling.patient,
		clinic: state => state.OnlineScheduling.clinic,
		appointmentType: state => state.OnlineScheduling.appointmentType,
		timeslot: state => state.OnlineScheduling.timeslot,
		clientToken: state => state.ClientToken.clientToken,
		displayAppointmentType() {
			if (this.appointmentType === 'FollowUp') {
				return 'Follow Up - CURRENT PATIENTS (30 MIN.)'
			} else {
				return 'Free Consultation - NEW PATIENTS (90 MIN.)'
			}
		},
		displayClinicAddress() {
			if (this.clinic) {
				return `${this.clinic.address}, ${this.clinic.city}, ${this.clinic.state} ${this.clinic.zipCode}`
			} else {
				return '';
			}
		},
		displayAppointmentDate() {
			return this.helpers().formatterLongDate(this.timeslot.dateTime)
		},
		displayAppointmentTime() {
			return this.helpers().formatterTime(this.timeslot.dateTime)
		}
	}),
	methods: {
		...mapActions('OnlineScheduling', { updateStep: 'updateStep' }),
		...mapActions('OnlineScheduling', { postScheduleAppointment: 'postScheduleAppointment' }),
		onCaptchaVerified(response) {
			this.recaptchaSuccess = true;
			this.recaptchaResponse = response;
		},
		onCaptchaExpired() {
			this.recaptchaSuccess = false;
			this.recaptchaResponse = null;
		},
		prevStep() {
			if (this.submitting) return;

			this.recaptchaSuccess = false;
			this.updateStep(2);
		},
		complete() {
			if (this.submitting) return;

			this.recaptchaSuccess = true;

			//if (!this.recaptchaResponse) {
			//	this.recaptchaSuccess = false;
			//	return false;
			//}

			this.submitting = true;
			let data = {
				recaptchaToken: this.recaptchaResponse,
				emailAddressVerify: this.form.emailAddressVerify,
				pageLoadedAtUtc: window.iframes.pageLoadedAtUtc,
				firstName: this.patient.firstName,
				lastName: this.patient.lastName,
				emailAddress: this.patient.emailAddress,
				phoneNumber: this.patient.phoneNumber,
				appointmentType: this.appointmentType,
				dateTime: this.timeslot.dateTime,
				staffId: this.timeslot.staffId,
				clinicId: this.clinic.id,
				clinic: this.clinic,
				isBringingFamiliarVoice: this.patient.bringingFamiliarVoice,
				familiarVoiceFirstName: this.patient.familiarVoiceFirstName,
				familiarVoiceLastName: this.patient.familiarVoiceLastName,
				companionTypeId: this.patient.relation ? this.patient.relation.id : null,
        utmSource: sessionStorage.getItem('utm_source'),
        utmMedium: sessionStorage.getItem('utm_medium'),
        utmCampaign: sessionStorage.getItem('utm_campaign'),
        utmContent: sessionStorage.getItem('utm_content'),
        referrerUrl: sessionStorage.getItem('referrer_url')
			}
			
			this.postScheduleAppointment({
				data,
				ClientToken: this.clientToken,
				cb: () => {
					this.submitting = false;
					this.goToThankYouPage();
				}
			})
		},
		goToThankYouPage() {
        window.top.location.href = `${document.referrer}thank-you-online-schedule/`;
    }
	},
	mounted() {
		const checkRecaptcha = () => {
			if (window.grecaptcha && window.grecaptcha.render && this.$refs.recaptcha) {
				if (!this.recaptchaRendered) {
					console.log("Rendering reCAPTCHA...");
					window.grecaptcha.render(this.$refs.recaptcha, {
						sitekey: this.recaptchaSiteKey,
						callback: this.onCaptchaVerified,
						'expired-callback': this.onCaptchaExpired
					});
					this.recaptchaRendered = true;
				}
			} else {
				console.log("Waiting for reCAPTCHA or ref to be ready...");
				setTimeout(checkRecaptcha, 500);
			}
		};

		checkRecaptcha();
	}
}
</script>